var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"brand-card-container"},[_c('client-only',[(_vm.showLogo)?_c('img',{staticClass:"logo mx-auto mb-6",attrs:{"src":_vm.logo}}):_vm._e()]),_vm._v(" "),_c('v-card',{class:{
      'loginBox mx-auto': true,
      'px-4 py-6': !this.$vuetify.breakpoint.xs,
      'px-2 py-6': this.$vuetify.breakpoint.xs,
      accent: this.$vuetify.breakpoint.mdAndUp && _vm.darkInnerCard,
      modalBackground: this.$vuetify.breakpoint.smAndDown || !_vm.darkInnerCard,
    },style:(("width: 100%; max-width: " + _vm.maxWidth + ";")),attrs:{"flat":""}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }